import {Promise} from "bluebird";
import {apiRequest} from "./ApiRequest";

const getAgents = params => {
    return apiRequest("get", "/agents", null, params).then(response => {
        return Promise.resolve(response.data);
    });
};

const getAgentDetails = agent => {
    return apiRequest("get", "/agents/" + agent.id).then(response => {
        return Promise.resolve(response.data);
    });
};

const editAgent = (id, data) => {
    return apiRequest("put", "/agents/" + id, data).then(response => {
        return Promise.resolve(response.data);
    });
};

const createAgent = data => {
    return apiRequest("post", "/agents", data).then(response => {
        return Promise.resolve(response.data);
    });
};

const deleteAgent = id => {
    return apiRequest("delete", "/agents/" + id).then(response => {
        return Promise.resolve(response.data);
    });
};

export {getAgents, getAgentDetails, editAgent, createAgent, deleteAgent};
